interface PartnerData {
  siteName: string;
  siteUrl: string;
}

const milfPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const indianPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Porndude.ai',
    siteUrl: 'https://https://porndude.ai/'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  }
];

const latinaPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Porndude.ai',
    siteUrl: 'https://https://porndude.ai/'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const bbwPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const ebonyPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Porndude.ai',
    siteUrl: 'https://https://porndude.ai/'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const shemalePartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Porndude.ai',
    siteUrl: 'https://https://porndude.ai/'
  },
  {
    siteName: 'Theporndude.vip',
    siteUrl: 'https://theporndude.vip/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/ai-shemale-generator/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'PornTourist - Best Porn Sites',
    siteUrl: 'http://porntourist.com/?ref=createaishemale.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'AI Porn Apps',
    siteUrl: 'https://aipornapps.com'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Fetishpreneur.ai',
    siteUrl: 'https://fetishpreneur.ai/'
  },
  {
    siteName: 'Hentaizilla',
    siteUrl: 'https://hentaizilla.com/shemale-hentai/'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'AI Gay Porn',
    siteUrl: ' https://gaymeister.com/ai-gay-porn/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const furryPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Theporndude.vip',
    siteUrl: 'https://theporndude.vip/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/furry-porn-ai-generator/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'PornTourist - Best Porn Sites',
    siteUrl: 'http://porntourist.com/?ref=createaifurry.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Fetishpreneur.ai',
    siteUrl: 'https://fetishpreneur.ai/'
  },
  {
    siteName: 'Hentaizilla',
    siteUrl: 'https://hentaizilla.com/furry-hentai/'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const gayPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Theporndude.vip',
    siteUrl: 'https://theporndude.vip/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'Mypornadviser.com',
    siteUrl: 'https://mypornadviser.com/'
  },
  {
    siteName: 'Fetishpreneur.ai',
    siteUrl: 'https://fetishpreneur.ai/'
  },
  {
    siteName: 'Bestpornsubscriptions.com',
    siteUrl: 'https://bestpornsubscriptions.com/'
  },
  {
    siteName: 'Bestgaysites.com',
    siteUrl: 'https://bestgaysites.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/gay-ai-porn-generator/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'PornTourist - Best Porn Sites',
    siteUrl: 'http://porntourist.com/?ref=createaigayporn.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Hentaizilla',
    siteUrl: 'https://hentaizilla.com/yaoi-hentai'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'Best Gay AI Porn Sites',
    siteUrl: ' https://gaymeister.com/ai-gay-porn/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const asianPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Porndude.ai',
    siteUrl: 'https://https://porndude.ai/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/ai-nude-asian-generator/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'PornTourist - Best Porn Sites',
    siteUrl: 'http://porntourist.com/?ref=createaiasian.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'Reach Porn',
    siteUrl: 'https://reachporn.com/'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
];

const hentaiPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Theporndude.vip',
    siteUrl: 'https://theporndude.vip/'
  },
  {
    siteName: 'Hentai Fucking',
    siteUrl: 'https://hentaifucking.com/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'thepornlist.net',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'Reach Porn',
    siteUrl: 'https://reachporn.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/create-hentai/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'PornTourist - Best Porn Sites',
    siteUrl: 'http://porntourist.com/?ref=createhentai.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Fetishpreneur.ai',
    siteUrl: 'https://fetishpreneur.ai/'
  },
  {
    siteName: 'Hentaizilla',
    siteUrl: 'https://hentaizilla.com/ai-hentai-generators/'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'txscz.com',
    siteUrl: 'https://txscz.com'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  }
  // Add more partners as needed
];

const pornPartners: PartnerData[] = [
  {
    siteName: 'The Porn Dude',
    siteUrl: 'https://theporndude.com'
  },
  {
    siteName: 'Theporndude.vip',
    siteUrl: 'https://theporndude.vip/'
  },
  {
    siteName: 'AI Generator Porn',
    siteUrl: 'https://aigeneratorporn.com/'
  },
  {
    siteName: 'Mypornadviser.com',
    siteUrl: 'https://mypornadviser.com/'
  },
  {
    siteName: 'Bestpornsubscriptions.com',
    siteUrl: 'https://bestpornsubscriptions.com/'
  },
  {
    siteName: 'Bestgaysites.com',
    siteUrl: 'https://bestgaysites.com/'
  },
  {
    siteName: 'AINSFWTools',
    siteUrl: 'https://www.ainsfwtools.com/tool/createporn-ai/'
  },
  {
    siteName: 'PaidPornSitesWorld',
    siteUrl: 'https://paidpornsitesworld.com/'
  },
  {
    siteName: 'Theporndork.com',
    siteUrl: 'https://porndork.com'
  },
  {
    siteName: 'Fetishpreneur.ai',
    siteUrl: 'https://fetishpreneur.ai/'
  },
  {
    siteName: 'Pornordo',
    siteUrl: 'https://pornordo.com/'
  },
  {
    siteName: 'Tube Porn List',
    siteUrl: 'https://tubepornlist.com/'
  },
  {
    siteName: 'The Best Fetish Sites',
    siteUrl: 'https://thebestfetishsites.com'
  },
  {
    siteName: 'Nichepornsites',
    siteUrl: 'https://nichepornsites.com/'
  },
  {
    siteName: 'Theporntourist',
    siteUrl: 'https://porntourist.com'
  },
  {
    siteName: 'The Porn Map',
    siteUrl: 'https://thepornmap.com/'
  },
  {
    siteName: 'NSFW.Tools',
    siteUrl: 'https://nsfw.tools'
  },
  {
    siteName: 'KinkedAI.com',
    siteUrl: 'https://kinkedai.com/'
  },
  {
    siteName: 'Best Premium Pornsite',
    siteUrl: 'https://bestpremiumpornsite.com/'
  },
  {
    siteName: 'AI Nude Generators',
    siteUrl: 'https://ainudegenerators.com/'
  },
  {
    siteName: 'NSFWAIBay',
    siteUrl: 'https://nsfwaibay.com/'
  },
  {
    siteName: 'Premiumpornlist',
    siteUrl: 'https://www.premiumpornlist.com/'
  },
  {
    siteName: 'XGLUZ',
    siteUrl: 'https://xgluz.com/ai-porn-sites/'
  },
  {
    siteName: 'AI Porn Apps',
    siteUrl: 'https://aipornapps.com'
  },
  {
    siteName: 'Hentaizilla',
    siteUrl: 'https://hentaizilla.com/ai-hentai-generators/'
  },
  {
    siteName: 'Foundr.AI',
    siteUrl: 'https://foundr.ai/embed/createporn-com'
  },
  {
    siteName: 'XXX',
    siteUrl: 'https://www.xxx.xxx/'
  },
  {
    siteName: 'The Porn Couch',
    siteUrl: 'https://theporncouch.com'
  },
  {
    siteName: 'Ultimate Premium XXX Sites List',
    siteUrl: 'https://bestpremiumpornsites.com'
  },
  {
    siteName: 'The Porn List',
    siteUrl: 'https://www.thepornlist.net/'
  },
  {
    siteName: 'Best Fetishes',
    siteUrl: 'https://www.bestfetishes.com/'
  },
  {
    siteName: 'ThePornLinks.com',
    siteUrl: 'https://thepornlinks.com/'
  },
  {
    siteName: 'The Porn Whitelist',
    siteUrl: 'https://pornwhitelist.com/'
  },
  {
    siteName: 'Thepornbest.com',
    siteUrl: 'https://www.thepornbest.com/'
  },
  {
    siteName: 'Best Porn Sites',
    siteUrl: 'https://www.thepornbin.com/'
  },
  {
    siteName: 'ThePornData',
    siteUrl: 'https://theporndata.com/'
  },
  {
    siteName: 'Ai Generators Porn',
    siteUrl: 'https://aigeneratorsporn.com/'
  },
  {
    siteName: 'EXXXTRA - Top Porn Sites List',
    siteUrl: 'http://exxxtra.net/'
  },
  {
    siteName: 'The Porn Blender',
    siteUrl: 'https://www.thepornblender.com/'
  },
  {
    siteName: 'The Porn Cat',
    siteUrl: 'https://theporncat.com/'
  },
  {
    siteName: '5 Star Porn Sites',
    siteUrl: 'http://fivestarpornsites.com/'
  },
  {
    siteName: 'Reach Porn',
    siteUrl: 'https://reachporn.com/'
  },
  {
    siteName: 'Findbare.com',
    siteUrl: 'https://findbare.com/'
  },
  {
    siteName: 'Lemonsight',
    siteUrl: 'https://lemonsight.com/categories/nfsw/'
  },
  {
    siteName: 'ThePorncall',
    siteUrl: 'https://www.theporncall.com'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://Pornlist18.Com'
  },
  {
    siteName: 'List of Porn Sites',
    siteUrl: 'https://pornsites.xxx/'
  },
  {
    siteName: 'Porn List 18+',
    siteUrl: 'https://pornlist18.com/'
  },
  {
    siteName: 'Pornrangers',
    siteUrl: ' https://pornrangers.com/?utm_source=createporn.com&utm_medium=Referral'
  },
  {
    siteName: 'YouPornList',
    siteUrl: 'https://www.youpornlist.com/'
  },
  {
    siteName: 'AnyPornSites',
    siteUrl: 'https://anypornsites.com/'
  },
  {
    siteName: 'Top Porn Sites',
    siteUrl: 'https://toplist18.com/'
  },
  {
    siteName: 'iPornList',
    siteUrl: 'https://ipornlist.com/'
  },
  {
    siteName: 'MainPornSites',
    siteUrl: 'https://mainpornsites.com/'
  },
  {
    siteName: 'All Porn Sites',
    siteUrl: 'https://allpornsites.net/'
  },
  {
    siteName: 'Best 3D New Porn',
    siteUrl: 'https://topcartoonpornsites.com/3d-porn-sites/'
  },
  {
    siteName: 'Top Premium Porn',
    siteUrl: 'https://toppremiumporn.com/'
  },
  {
    siteName: 'AI Generation Porn',
    siteUrl: 'http://aigenerationporn.com/'
  },
  {
    siteName: 'Musclegirldirectory.com',
    siteUrl: 'https://www.musclegirldirectory.com/'
  },
  {
    siteName: 'Porn Pay Sites',
    siteUrl: 'https://pornpaysites.net/'
  },
  {
    siteName: 'Pornsitesguide.com',
    siteUrl: 'https://pornsitesguide.com/'
  },
  {
    siteName: 'Pornaigeneration.com',
    siteUrl: 'https://pornaigeneration.com/'
  },
  {
    siteName: 'Theporngoat.com',
    siteUrl: 'https://theporngoat.com/'
  },
  {
    siteName: 'BeyondAIPorn',
    siteUrl: 'https://beyondaiporn.com/'
  },
  {
    siteName: 'Trans Porn Sites',
    siteUrl: 'https://www.transpornsites.com/'
  },
  {
    siteName: 'Gay Porn Menu',
    siteUrl: 'https://www.gaypornmenu.com/'
  },
  {
    siteName: 'thepornlogs.com',
    siteUrl: 'https://thepornlogs.com/'
  },
  {
    siteName: 'Porndork.com',
    siteUrl: 'https://porndork.com/'
  },
  {
    siteName: 'freeporned',
    siteUrl: 'https://freeporned.com/'
  },
  {
    siteName: 'AdultList',
    siteUrl: 'https://adultlist.net/'
  },
  {
    siteName: 'AItoolnet',
    siteUrl: 'https://www.aitoolnet.com'
  },
  {
    siteName: 'Datingtools.AI',
    siteUrl: 'https://datingtools.ai/'
  },
  {
    siteName: 'My Porn Dir',
    siteUrl: 'https://myporndir.com/'
  },
  {
    siteName: 'Top Class Porn Sites',
    siteUrl: 'https://topClassLinks/?ref=createporn/'
  },
  {
    siteName: 'Best Porn 2024',
    siteUrl: 'https://buypremiumporn.com/'
  },
  {
    siteName: 'Live Free Adult Cams',
    siteUrl: 'https://babestationcams.com/'
  },
  {
    siteName: 'Dominatrix Cams',
    siteUrl: 'https://femdomlive.com/dominatrix-cams/'
  },
  {
    siteName: 'Fetish Chat Rooms',
    siteUrl: ' https://fetishcams-live.com/fetish-chat-rooms/'
  },
  {
    siteName: 'Nairobi Escorts',
    siteUrl: 'https://www.exotickenya.com/escorts-from/nairobi-escorts/'
  },
  {
    siteName: 'Muscle Girl Porn',
    siteUrl: 'https://musclegirlflix.com/'
  },
  {
    siteName: 'NSFW AI Directory',
    siteUrl: 'https://bestnsfw.ai/'
  },
  {
    siteName: 'Best Porn Sites',
    siteUrl: 'https://pornsites.com/'
  },
  {
    siteName: 'Pornai.ch',
    siteUrl: 'https://pornai.ch/'
  },
  {
    siteName: 'AI Girlfriend Online Free',
    siteUrl: 'https://www.morningdough.com/aigf/'
  },
  {
    siteName: 'Arktan',
    siteUrl: ' https://arktan.com/best-ai-porn-generators/'
  },
  {
    siteName: 'Coeros.com',
    siteUrl: 'https://www.coeros.com'
  }
  // Add more partners as needed
];

const siblingPornSites: Array<{ name: string; url: string }> = [
  { name: 'AIPorn', url: 'https://www.createporn.com' },
  { name: 'AIShemale', url: 'https://www.createaishemale.com' },
  { name: 'AIHentai', url: 'https://www.createhentai.com' },
  { name: 'AIAsian', url: 'https://www.createaiasian.com' },
  { name: 'AIGayPorn', url: 'https://www.createaigayporn.com' },
  { name: 'AIFurry', url: 'https://www.createaifurry.com' },
  { name: 'AIEbony', url: 'https://www.createaiebony.com' },
  { name: 'AIBBW', url: 'https://www.createaibbw.com' },
  { name: 'AILatina', url: 'https://www.createailatina.com' },
  { name: 'AIIndian', url: 'https://www.createaiindian.com' },
  { name: 'AIMilf', url: 'https://www.createaimilf.com' }
  // { name: "PornGames", url: "https://www.nutaku.net/signup/landing/project-qt/2/?ats=eyJhIjo5OTg3NzIsImMiOjYxNzczMzM2LCJuIjoxLCJzIjoxLCJlIjo5MjM4LCJwIjoyfQ==" },
  // TODO: enable these sites
];

const siblingHentaiSites: Array<{ name: string; url: string }> = [
  { name: 'AIPorn', url: 'https://www.createporn.com' },
  { name: 'AIHentai', url: 'https://www.createhentai.com' },
  { name: 'AIShemale', url: 'https://www.createaishemale.com' },
  { name: 'AIAsian', url: 'https://www.createaiasian.com' },
  { name: 'AIGayPorn', url: 'https://www.createaigayporn.com' },
  { name: 'AIFurry', url: 'https://www.createaifurry.com' },
  { name: 'AIEbony', url: 'https://www.createaiebony.com' },
  { name: 'AIBBW', url: 'https://www.createaibbw.com' },
  { name: 'AILatina', url: 'https://www.createailatina.com' },
  { name: 'AIIndian', url: 'https://www.createaiindian.com' },
  { name: 'AIMilf', url: 'https://www.createaimilf.com' }
  // { name: "PornGames", url: "https://www.nutaku.net/signup/landing/project-qt/2/?ats=eyJhIjo5OTg3NzIsImMiOjYxNzczMzM2LCJuIjoxLCJzIjoxLCJlIjo5MjM4LCJwIjoyfQ==" },
  // TODO: enable these sites
];

function removeSiteByName(sitesArray: Array<{ name: string; url: string }>, siteName: string) {
  return sitesArray.filter((site) => site.name !== siteName);
}

export const siteConfigurations = [
  {
    origin: 0,
    category: 'Porn',
    siteName: 'CreatePorn',
    siteNameFull: 'CreatePorn.com',
    siteUrl: 'https://www.createporn.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'CreatePorn'),
    shortLogo: 'https://cdn6.imgpog.com/newLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreatePorn-', // + locale + webp
    openGraphSiteName: 'Create Porn',
    shortLogoWidth: 30,
    shortLogoHeight: 17,
    fullLogo: 'https://cdn6.imgpog.com/newLogoFull.svg',
    fullLogoWidth: 190,
    fullLogoHeight: 18.465,
    mobileLogo: 'https://cdn6.imgpog.com/newLogoMobile.svg',
    mobileLogoWidth: 140,
    mobileLogoHeight: 16.165,
    bannerLarge: 'https://cdn6.imgpog.com/crp_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crp_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crp_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crp_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitle',
    postSEOTitle: 'postSEOTitle',
    create: 'create',
    affiliatePartners: pornPartners,
    subredditName: '/r/createAIart',
    twitterLink: 'https://x.com/CreateAIArts',
    twitterHandle: '@CreateAIArts',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/upgrade_5.webp',
      title2: 'https://cdn6.imgpog.com/upgrade_4.webp',
      title3: 'https://cdn6.imgpog.com/upgrade_6.webp'
    }
  },
  {
    origin: 1,
    category: 'GayPorn',
    siteName: 'CreateGayPorn',
    siteNameFull: 'CreateAIGayPorn.com',
    siteUrl: 'https://www.createaigayporn.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIGayPorn'),
    shortLogo: 'https://cdn6.imgpog.com/boyfriendLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateGayPorn-', // + locale + webp
    openGraphSiteName: 'Create Gay Porn',
    shortLogoWidth: 20,
    shortLogoHeight: 20,
    fullLogo: 'https://cdn6.imgpog.com/boyfriendLogoFull.svg',
    fullLogoWidth: 220,
    fullLogoHeight: 20.63,
    mobileLogo: 'https://cdn6.imgpog.com/boyfriendLogoMobile.svg',
    mobileLogoWidth: 155,
    mobileLogoHeight: 16.75,
    bannerLarge: 'https://cdn6.imgpog.com/crgp_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crgp_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crgp_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crgp_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitleg',
    postSEOTitle: 'postSEOTitleg',
    create: 'createg',
    affiliatePartners: gayPartners,
    subredditName: '/r/createAIgayporn',
    twitterLink: 'https://x.com/CreateAIGayPorn',
    twitterHandle: '@CreateAIGayPorn',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crgp_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crgp_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crgp_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crgp_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crgp_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crgp_gems_1.webp',
      title3: 'https://cdn6.imgpog.com/crgp_upgrade_3.webp'
    }
  },
  {
    origin: 2,
    category: 'Hentai',
    siteName: 'CreateHentai',
    siteNameFull: 'CreateHentai.com',
    siteUrl: 'https://www.createhentai.com',
    sibilingSites: removeSiteByName(siblingHentaiSites, 'AIHentai'),
    shortLogo: 'https://cdn6.imgpog.com/hentaiLogoShort.webp',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateHentai-', // + locale + webp
    openGraphSiteName: 'Create Hentai',
    shortLogoWidth: 30,
    shortLogoHeight: 34.39,
    fullLogo: 'https://cdn6.imgpog.com/hentaiLogoFull.webp',
    fullLogoWidth: 200,
    fullLogoHeight: 36.43,
    mobileLogo: 'https://cdn6.imgpog.com/hentaiLogoMobile.webp',
    mobileLogoWidth: 140,
    mobileLogoHeight: 29.77,
    bannerLarge: 'https://cdn6.imgpog.com/crh_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crh_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crh_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crh_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitleh',
    postSEOTitle: 'postSEOTitleh',
    create: 'createh',
    affiliatePartners: hentaiPartners,
    subredditName: '/r/createAIhentai',
    twitterLink: 'https://x.com/CreateAIHentai',
    twitterHandle: '@CreateAIHentai',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crh_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crh_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crh_upgrade_3.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/upgrade_5.webp',
      title2: 'https://cdn6.imgpog.com/crh_gems_1.webp',
      title3: 'https://cdn6.imgpog.com/crh_gems_2.webp'
    }
  },
  {
    origin: 3,
    category: 'Furry',
    siteName: 'CreateAIFurry',
    siteNameFull: 'CreateAIFurry.com',
    siteUrl: 'https://www.createaifurry.com',
    sibilingSites: removeSiteByName(siblingHentaiSites, 'AIFurry'),
    shortLogo: 'https://cdn6.imgpog.com/furryLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateAIFurry-', // + locale + webp
    openGraphSiteName: 'Create AI Furry',
    shortLogoWidth: 25,
    shortLogoHeight: 31.95,
    fullLogo: 'https://cdn6.imgpog.com/furryLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 22.47,
    mobileLogo: 'https://cdn6.imgpog.com/furryLogoMobile.svg',
    mobileLogoWidth: 140,
    mobileLogoHeight: 18.26,
    bannerLarge: 'https://cdn6.imgpog.com/crf_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crf_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crf_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crf_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlef',
    postSEOTitle: 'postSEOTitlef',
    create: 'createf',
    affiliatePartners: furryPartners,
    subredditName: '/r/createAIfurry',
    twitterLink: 'https://x.com/CreateAIFurry',
    twitterHandle: '@CreateAIFurry',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crf_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crf_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crf_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crf_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crf_gems_1.webp',
      title2: 'https://cdn6.imgpog.com/crf_gems_2.webp',
      title3: 'https://cdn6.imgpog.com/crf_gems_3.webp'
    }
  },
  {
    origin: 4,
    category: 'AsianPorn',
    siteName: 'CreateAsian',
    siteNameFull: 'CreateAIAsian.com',
    siteUrl: 'https://www.createaiasian.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIAsian'),
    shortLogo: 'https://cdn6.imgpog.com/asianLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateAsian-', // + locale + webp
    openGraphSiteName: 'Create Asian',
    shortLogoWidth: 25,
    shortLogoHeight: 22.92,
    fullLogo: 'https://cdn6.imgpog.com/asianLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 21.21,
    mobileLogo: 'https://cdn6.imgpog.com/asianLogoMobile.svg',
    mobileLogoWidth: 140,
    mobileLogoHeight: 17.69,
    bannerLarge: 'https://cdn6.imgpog.com/cra_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/cra_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/cra_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/cra_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlea',
    postSEOTitle: 'postSEOTitlea',
    create: 'create', //intended without a, other wise too much text will be on this button
    affiliatePartners: asianPartners,
    subredditName: '/r/createAIasian',
    twitterLink: 'https://x.com/CreateAIAsian',
    twitterHandle: '@CreateAIAsian',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/cra_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/cra_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/cra_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/cra_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/cra_upgrade_3.webp',
      title2: 'https://cdn6.imgpog.com/cra_upgrade_4.webp',
      title3: 'https://cdn6.imgpog.com/cra_upgrade_1.webp'
    }
  },
  {
    origin: 5,
    category: 'ShemalePorn',
    siteName: 'CreateShemale',
    siteNameFull: 'CreateAIShemale.com',
    siteUrl: 'https://www.createaishemale.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIShemale'),
    shortLogo: 'https://cdn6.imgpog.com/shemaleLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateShemale-', // + locale + webp
    openGraphSiteName: 'Create Shemale',
    shortLogoWidth: 25,
    shortLogoHeight: 20.46,
    fullLogo: 'https://cdn6.imgpog.com/shemaleLogoFull.svg',
    fullLogoWidth: 220,
    fullLogoHeight: 18.51,
    mobileLogo: 'https://cdn6.imgpog.com/shemaleLogoMobile.svg',
    mobileLogoWidth: 155,
    mobileLogoHeight: 13.62,
    bannerLarge: 'https://cdn6.imgpog.com/crsm_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crsm_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crsm_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crsm_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitles',
    postSEOTitle: 'postSEOTitles',
    create: 'creates',
    affiliatePartners: shemalePartners,
    subredditName: '/r/createAIshemale',
    twitterLink: 'https://x.com/CreateAIShemale',
    twitterHandle: '@CreateAIShemale',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crsm_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crsm_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crsm_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crsm_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crsm_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crsm_gems_1.webp',
      title3: 'https://cdn6.imgpog.com/crsm_upgrade_4.webp'
    }
  },
  {
    origin: 6,
    category: 'EbonyPorn',
    siteName: 'CreateEbony',
    siteNameFull: 'CreateAIEbony.com',
    siteUrl: 'https://www.createaiebony.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIEbony'),
    shortLogo: 'https://cdn6.imgpog.com/ebonyLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateEbony-', // + locale + webp
    openGraphSiteName: 'Create Ebony',
    shortLogoWidth: 20,
    shortLogoHeight: 17.27,
    fullLogo: 'https://cdn6.imgpog.com/ebonyLogoFull.svg',
    fullLogoWidth: 220,
    fullLogoHeight: 18.51,
    mobileLogo: 'https://cdn6.imgpog.com/ebonyLogoMobile.svg',
    mobileLogoWidth: 160,
    mobileLogoHeight: 19.47,
    bannerLarge: 'https://cdn6.imgpog.com/cre_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/cre_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/cre_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/cre_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlee',
    postSEOTitle: 'postSEOTitlee',
    create: 'createe',
    affiliatePartners: ebonyPartners,
    subredditName: '/r/createAIebony',
    twitterLink: 'https://x.com/CreateAIEbony',
    twitterHandle: '@CreateAIEbony',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crp_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crp_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crp_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crp_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crp_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crp_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crp_upgrade_4.webp'
    }
  },
  {
    origin: 7,
    category: 'BBWPorn',
    siteName: 'CreateBBW',
    siteNameFull: 'CreateAIBBW.com',
    siteUrl: 'https://www.createaibbw.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIBBW'),
    shortLogo: 'https://cdn6.imgpog.com/bbwLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateBBW-', // + locale + webp
    openGraphSiteName: 'Create BBW',
    shortLogoWidth: 20,
    shortLogoHeight: 20,
    fullLogo: 'https://cdn6.imgpog.com/bbwLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 19.05,
    mobileLogo: 'https://cdn6.imgpog.com/bbwLogoMobile.svg',
    mobileLogoWidth: 150,
    mobileLogoHeight: 17.19,
    bannerLarge: 'https://cdn6.imgpog.com/crbbw_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crbbw_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crbbw_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crbbw_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitleb',
    postSEOTitle: 'postSEOTitleb',
    create: 'createb',
    affiliatePartners: bbwPartners,
    subredditName: '/r/createAIbbw',
    twitterLink: 'https://x.com/CreateAIBBW',
    twitterHandle: '@CreateAIBBW',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crbbw_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crbbw_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crbbw_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crbbw_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crbbw_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crbbw_upgrade_3.webp',
      title3: 'https://cdn6.imgpog.com/crbbw_gems_2.webp'
    }
  },
  {
    origin: 8,
    category: 'LatinaPorn',
    siteName: 'CreateLatina',
    siteNameFull: 'CreateAILatina.com',
    siteUrl: 'https://www.createailatina.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AILatina'),
    shortLogo: 'https://cdn6.imgpog.com/latinaLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateLatina-', // + locale + webp
    openGraphSiteName: 'Create Latina',
    shortLogoWidth: 22.5,
    shortLogoHeight: 22.5,
    fullLogo: 'https://cdn6.imgpog.com/latinaLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 20.38,
    mobileLogo: 'https://cdn6.imgpog.com/latinaLogoMobile.svg',
    mobileLogoWidth: 155,
    mobileLogoHeight: 13.62,
    bannerLarge: 'https://cdn6.imgpog.com/crl_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crl_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crl_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crl_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlel',
    postSEOTitle: 'postSEOTitlel',
    create: 'createl',
    affiliatePartners: latinaPartners,
    subredditName: '/r/createAIlatina',
    twitterLink: 'https://x.com/CreateAILatina',
    twitterHandle: '@CreateAILatina',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crl_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crl_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crl_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crl_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crl_upgrade_3.webp',
      title2: 'https://cdn6.imgpog.com/crl_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crl_gems_1.webp'
    }
  },
  {
    origin: 9,
    category: 'IndianPorn',
    siteName: 'CreateIndian',
    siteNameFull: 'CreateAIIndian.com',
    siteUrl: 'https://www.createaiindian.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIIndian'),
    shortLogo: 'https://cdn6.imgpog.com/indianLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateIndian-', // + locale + webp
    openGraphSiteName: 'Create Indian',
    shortLogoWidth: 18,
    shortLogoHeight: 18.5,
    fullLogo: 'https://cdn6.imgpog.com/indianLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 20.5,
    mobileLogo: 'https://cdn6.imgpog.com/indianLogoMobile.svg',
    mobileLogoWidth: 155,
    mobileLogoHeight: 13.62,
    bannerLarge: 'https://cdn6.imgpog.com/cri_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/cri_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/cri_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/cri_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlei',
    postSEOTitle: 'postSEOTitlei',
    create: 'createi',
    affiliatePartners: indianPartners,
    subredditName: '/r/createAIindian',
    twitterLink: 'https://x.com/CreateAIindian',
    twitterHandle: '@CreateAIIndian',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/cri_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/cri_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/cri_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/cri_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/cri_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/cri_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/cri_upgrade_3.webp'
    }
  },
  {
    origin: 10,
    category: 'MilfPorn',
    siteName: 'CreateMilf',
    siteNameFull: 'CreateAIMilf.com',
    siteUrl: 'https://www.createaimilf.com',
    sibilingSites: removeSiteByName(siblingPornSites, 'AIMilf'),
    shortLogo: 'https://cdn6.imgpog.com/milfLogoShort.svg',
    openGraphImage: 'https://cdn6.imgpog.com/og-CreateMilf-', // + locale + webp
    openGraphSiteName: 'Create Milf',
    shortLogoWidth: 25,
    shortLogoHeight: 20.46,
    fullLogo: 'https://cdn6.imgpog.com/milfLogoFull.svg',
    fullLogoWidth: 200,
    fullLogoHeight: 20.5,
    mobileLogo: 'https://cdn6.imgpog.com/milfLogoMobile.svg',
    mobileLogoWidth: 155,
    mobileLogoHeight: 13.62,
    bannerLarge: 'https://cdn6.imgpog.com/crm_banner.webp',
    bannerLargeWidth: 1900,
    bannerLargeHeight: 1599,
    bannerMedium: 'https://cdn6.imgpog.com/crm_banner_med.webp',
    bannerMediumWidth: 867,
    bannerMediumHeight: 730,
    bannerSmall: 'https://cdn6.imgpog.com/crm_thumbnail_lg.webp',
    bannerSmallWidth: 240,
    bannerSmallHeight: 240,
    bannerThumbnail: 'https://cdn6.imgpog.com/crm_thumbnail.webp',
    bannerThumbnailWidth: 45,
    bannerThumbnailHeight: 58,
    mainSEOTitle: 'mainSEOTitlem',
    postSEOTitle: 'postSEOTitlem',
    create: 'createm',
    affiliatePartners: milfPartners,
    subredditName: '/r/createAImilf',
    twitterLink: 'https://x.com/CreateAIMilf',
    twitterHandle: '@CreateAIMilf',
    subPropImages: {
      title1: 'https://cdn6.imgpog.com/crm_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crm_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crm_upgrade_3.webp',
      title4: 'https://cdn6.imgpog.com/crm_upgrade_4.webp'
    },
    gemPropImages: {
      title1: 'https://cdn6.imgpog.com/crm_upgrade_1.webp',
      title2: 'https://cdn6.imgpog.com/crm_upgrade_2.webp',
      title3: 'https://cdn6.imgpog.com/crm_gems_1.webp'
    }
  }
];

// Determine the site configuration at build time
const SITE_CONFIG_INDEX = (() => {
  switch (process.env.NEXT_PUBLIC_BASE_URL) {
    case 'https://www.createporn.com':
      return 0;
    case 'https://www.createaigayporn.com':
      return 1;
    case 'https://www.createhentai.com':
      return 2;
    case 'https://www.createaifurry.com':
      return 3;
    case 'https://www.createaiasian.com':
      return 4;
    case 'https://www.createaishemale.com':
      return 5;
    case 'https://www.createaiebony.com':
      return 6;
    case 'https://www.createaibbw.com':
      return 7;
    case 'https://www.createailatina.com':
      return 8;
    case 'https://www.createaiindian.com':
      return 9;
    case 'https://www.createaimilf.com':
      return 10;
    default:
      return 0;
  }
})();

// Export the configuration directly - this is computed once at build time
export const siteConfiguration = siteConfigurations[SITE_CONFIG_INDEX];

export const IS_MAIN_SITE = siteConfiguration.category === 'Porn';

// Analytics website ID - computed once at build time
export const ANALYTICS_WEBSITE_ID = (() => {
  if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createporn.com') {
    return 'fbe6862c4f3f';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaigayporn.com') {
    return '5eb9cc63584a';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createhentai.com') {
    return '021c5de87b96';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaifurry.com') {
    return '08ae3e0c9c53';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaiasian.com') {
    return 'e1a683103cac';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaishemale.com') {
    return '05aa88858e95';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaiebony.com') {
    return '369581fc9d15';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaibbw.com') {
    return '349b6f9e3fc0';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createailatina.com') {
    return '2726fb14cb4a';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaiindian.com') {
    return '4b03324bfa71';
  } else if (process.env.NEXT_PUBLIC_BASE_URL === 'https://www.createaimilf.com') {
    return 'ca9c8a6ca1bd';
  }

  return '';
})();
